import { styled } from "@mui/material";
import SvgEdit from "./images/edit.svg.js";
import { shouldNotForwardProps } from "../../utils/shouldNotForwardProps.js";
const sizes = {
  xs: "24px",
  sm: "42px",
  md: "54px",
  lg: "72px",
  xl: "102px"
}, variants = {
  xs: "12_16_700",
  sm: "16_20_700",
  md: "20_24_700",
  lg: "24_32_700",
  xl: "32_40_700"
}, StyledAvatar = styled(
  "button",
  shouldNotForwardProps([
    "square",
    "size",
    "disabled",
    "withImage",
    "withEditMode"
  ])
)(({
  theme,
  square,
  size = "md",
  disabled,
  withImage,
  withEditMode,
  onClick
}) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontWeight: 600,
  fontSize: "32px",
  lineHeight: "36px",
  width: sizes[size],
  minWidth: sizes[size],
  height: sizes[size],
  minHeight: sizes[size],
  boxSizing: "border-box",
  position: "relative",
  border: "none",
  ...square ? {
    borderRadius: "unset"
  } : {
    borderRadius: "50%"
  },
  "& .avatar-image": {
    width: sizes[size],
    minWidth: sizes[size],
    height: sizes[size],
    minHeight: sizes[size],
    zIndex: 1,
    ...square ? {
      borderRadius: "unset"
    } : {
      borderRadius: "50%"
    }
  },
  ".avatar-name": {
    position: "absolute"
  },
  ...disabled ? {
    backgroundColor: theme.palette.grey[300],
    color: theme.palette.grey[700],
    cursor: "default",
    ...withImage && {
      opacity: "50%"
    }
  } : {
    color: theme.palette.white.main,
    backgroundColor: theme.palette.secondary[600],
    cursor: "pointer",
    "&:hover": {
      backgroundColor: theme.palette.secondary[700],
      ...withEditMode && {
        ".avatar-edit-icon": {
          display: "block",
          zIndex: 1
        },
        ".avatar-name": {
          display: "none"
        }
      }
    },
    "&:active": {
      backgroundColor: theme.palette.secondary[900]
    },
    ...withImage && {
      backgroundColor: "unset",
      "&:hover": {
        backgroundColor: "unset",
        opacity: "50%",
        ...withEditMode && {
          opacity: 1,
          ".avatar-edit-icon": {
            display: "block",
            zIndex: 2
          },
          "&:before": {
            position: "absolute",
            backgroundColor: theme.palette.secondary[700],
            zIndex: 2,
            width: "100%",
            height: "100%",
            content: '""',
            opacity: "80%",
            borderRadius: square ? "unset" : "50%",
            border: `1px solid ${theme.palette.secondary[700]}`
          }
        }
      },
      "&:active": {
        backgroundColor: "unset",
        opacity: "30%",
        ...withEditMode && {
          opacity: 1,
          "&:before": {
            backgroundColor: theme.palette.secondary[900],
            opacity: "90%",
            border: `1px solid ${theme.palette.secondary[900]}`
          }
        }
      }
    }
  },
  ...!onClick && {
    pointerEvents: "none"
  }
})), StyledEditIcon = styled(SvgEdit)(({ theme }) => ({
  position: "absolute",
  display: "none",
  color: theme.palette.white.main,
  zIndex: 1
}));
export {
  StyledAvatar,
  StyledEditIcon,
  variants
};
//# sourceMappingURL=styles.js.map
